export default "__VITE_ASSET__BAv4XFSc__"